import React from 'react';
import {IndexRouter} from "./route/IndexRoute";
import './assets/style/font.less';
import './assets/style/base.less';
import './assets/style/common.less';
import './assets/style/cover.less';


function App() {
	return (
		<IndexRouter />
	);
}

export default App;
